import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(() => {
        try {
            const savedCart = localStorage.getItem('cart');
            return savedCart ? JSON.parse(savedCart) : {};
        } catch (error) {
            console.error('Error parsing cart from localStorage:', error);
            // Clear corrupted cart data
            localStorage.removeItem('cart');
            return {};
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('cart', JSON.stringify(cart));
        } catch (error) {
            console.error('Error saving cart to localStorage:', error);
            // If localStorage is full or corrupted, try to clear it and retry
            try {
                localStorage.removeItem('cart');
                localStorage.setItem('cart', JSON.stringify(cart));
            } catch (retryError) {
                console.error('Failed to save cart even after clearing localStorage:', retryError);
            }
        }
    }, [cart]);

    const addToCart = (item, quantity) => {
        console.log('🛒 CartContext.addToCart called');
        console.log('🛒 Item:', item);
        console.log('🛒 Quantity:', quantity);
        
        if (!item || !item.id) {
            console.error('❌ CartContext: Invalid item provided', item);
            return;
        }
        
        setCart(prevCart => {
            console.log('🛒 Previous cart:', prevCart);
            const updatedCart = { ...prevCart };
            const previousQuantity = updatedCart[item.id]?.quantity || 0;
            const newQuantity = previousQuantity + quantity;
            
            updatedCart[item.id] = {
                id: item.id,
                quantity: newQuantity,
                category_id: (item.category_id !== undefined && item.category_id !== '') ? String(item.category_id) : (localStorage.getItem('category_id') || '')
            };
            
            console.log('🛒 Updated cart:', updatedCart);
            console.log('🛒 Item quantity:', previousQuantity, '->', newQuantity);
            
            // Update local storage
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            console.log('🛒 Cart saved to localStorage');
            
            return updatedCart;
        });
    };

                const updateQuantity = (id, quantity) => {
            setCart(prevCart => ({
                ...prevCart,
                [id]: { ...prevCart[id], quantity }
            }));
        };

        const removeFromCart = (id) => {
            setCart(prevCart => {
                const newCart = { ...prevCart };
                delete newCart[id];
                return newCart;
            });
        };

        const clearCart = () => {
            setCart({});
        }

        return (
            <CartContext.Provider value={{ cart, addToCart, updateQuantity, removeFromCart, clearCart }}>
                {children}
            </CartContext.Provider>
        );
    };